# This file is part of Tibia Wheel.
# Copyright (c) 2022 Maciej Sopyło
# 
# This data file is covered by the CC BY-SA 3.0 license
# for compatibility with TibiaWiki

dedication:
  - name: hp
    icon: 0
    template: +%1 Hit Points
    effect:
      knight: [ 3 ]
      paladin: [ 2 ]
      druid: [ 1 ]
      sorcerer: [ 1 ]
      monk: [ 2 ]
  - name: mana
    icon: 1
    template: +%1 Mana
    effect:
      knight: [ 1 ]
      paladin: [ 3 ]
      druid: [ 6 ]
      sorcerer: [ 6 ]
      monk: [ 2 ]
  - name: hp_mana
    icon: 2
    template: +%1/+%2 Hit Points/Mana
    effect:
      knight: [ 3, 1]
      paladin: [ 2, 3 ]
      druid: [ 1, 6 ]
      sorcerer: [ 1, 6 ]
      monk: [ 2, 2 ]
  - name: capacity
    icon: 3
    template: +%1 Capacity
    effect:
      knight: [ 5 ]
      paladin: [ 4 ]
      druid: [ 2 ]
      sorcerer: [ 2 ]
      monk: [ 5 ]
  - name: hp_regen_boost_chance
    icon: 4
    template: +%1% HP regen burst chance
    effect: [ 0.2 ]
  - name: mana_regen_boost_chance
    icon: 5
    template: +%1% MP regen burst chance
    effect: [ 0.2 ]
  - name: familiar_expertise
    icon: 6
    template: "+%1%/+%2% familiar health/damage"
    effect: [ 0.3, 0.1 ]
  - name: familiar_cooldown
    icon: 7
    template: -%1s familiar cooldown
    effect: [ 1 ]
  - name: mitigation
    icon: 8
    template: +%1% Mitigation Multiplier
    effect: [ 0.07 ]

conviction:
  - name: Fire Resistance
    template: +%1% fire resistance
    amount: 2
  - name: Energy Resistance
    template: +%1% energy resistance
    amount: 2
  - name: Ice Resistance
    template: +%1% ice resistance
    amount: 2
  - name: Earth Resistance
    template: +%1% earth resistance
    amount: 2
  - name: Holy/Death Resistance
    template: +%1% holy and death resistance
    amount: 1
  - name: Mana Leech
    template: +%1% mana leech
    amount: 0.25
  - name: Life Leech
    template: +%1% life leech
    amount: 0.75
  - name: Weapon Skill Boost
    template: +%1 weapon skill boost
    amount: 1
  - name: Battle Instinct
    template: "Gain +%1 shielding and +%2 sword/axe/club fighting when %3 creatures are on adjacent squares.\nFor each additional creature, up to a maximum of %4, you get +%1 shielding and +%2 sword/axe/club fighting more."
    params: [ 6, 1, 5, 8 ]
  - name: Battle Healing
    template: "Healing Spells have %1% increased healing. This bonus is doubled when wearing a shield."
    params: [ 10 ]
  - name: Augmented Fierce Berserk
    t1: -30 Mana Cost
    t2: +10% Base Damage
  - name: Augmented Intense Wound Cleansing
    t1: +125% Base Healing
    t2: "-60s Cooldown"
  - name: Augmented Front Sweep
    t1: +40% Base Damage
    t2: Expanded Shape
  - name: Augmented Groundshaker
    t1: "-2s Cooldown"
    t2: +12.5% Base Damage
  - name: Augmented Shield Slam
    t1: Adds 15% life leech to this spell
    t2: -25% damage from the next hostile auto attack
  - name: Distance Skill Boost
    template: +%1 distance skill boost
    amount: 1
  - name: Ballistic Mastery
    template: "The critical extra damage for attacks with a crossbow is increased by %1%.\nWhile wielding a bow your attacks and spells have +%2% physical and holy pierce."
    params: [ 10, 4 ]
  - name: Positional Tactics
    template: "Gain +%1 distance fighting while no monster is within 1 square. Otherwise gain +%2 holy magic level and +%3 healing magic level."
    params: [ 3, 3, 3 ]
  - name: Augmented Divine Caldera
    t1: -20 Mana Cost
    t2: +10% Base Damage
  - name: Augmented Divine Barrage
    t1: +8% Base Damage
    t2: +12% Base Damage
  - name: Augmented Divine Dazzle
    t1: Jumps to +2 additional targets
    t2: Duration increased; -8s Cooldown
  - name: Augmented Strong Ethereal Spear
    t1: -2s Cooldown
    t2: +380% Base Damage
  - name: Augmented Ethereal Barrage
    t1: Adds 10% life leech to this spell
    t2: Adds 10% critical hit chance for this spell.
  - name: Focus Mastery
    template: "Increases the damage of your next damage spell by %1% within %2 seconds after casting a focus spell. Reduces the primary cooldown by %3 seconds."
    params: [ 35, 12, 2 ]
  - name: Augmented Great Fire Wave
    t1: Adds 15% critical extra damage for this spell.
    t2: +5% Base Damage
  - name: Augmented Energy Wave
    t1: Affected area enlarged
    t2: +10% Base Damage
  - name: Augmented Special Spells
    t1: -4s Cooldown for Lightning, Strong Energy Strike and Strong Flame Strike
    t2: +50% Base Damage for Lightning, Strong Energy Strike and Strong Flame Strike
  - name: Augmented Focus Spells
    t1: +5% Base Damage for Hell's Core and Rage of the Skies
    t2: -4s Cooldown; Focus secondary group cooldown -4s for Hell's Core and Rage of the Skies
  - name: Healing Link
    template: "If you heal someone with Nature's Embrace or Heal Friend, you also heal yourself for %1% of the applied healing."
    params: [ 25 ]
  - name: Augmented Forked Spells
    t1: -2s Cooldown for Forked Thorns and Forked Glacier
    t2: Jumps to +1 additional target for Forked Thorns and Forked Glacier
  - name: Augmented Terra Wave
    t1: +6.5% Base Damage
    t2: Adds 10% life leech to this spell
  - name: Augmented Strong Ice Wave
    t1: +6% Base Damage
    t2: Expanded Shape
  - name: Augmented Mass Healing
    t1: +4% Base Healing
    t2: Affected area enlarged
  - name: Augmented Heal Friend
    t1: +4% Base Healing
    t2: +6% Base Healing
  - name: Magic Skill Boost
    template: +%1 magic skill boost
    amount: 1
  - name: Runic Mastery
    template: "If you use a rune, you have a %1% chance of increasing your magic level by %2%, or by %3% if you use a rune that can be created by your vocation."
    params: [ 25, 10, 20 ]
  - name: Augmented Death Echo
    t1: -2s Cooldown
    t2: +12% Base Damage
  - name: Vessel Resonance Top Left
    template: "Each level of Vessel Resonance unlocks equivalent Gem Mods in its domain. If the Vessel Resonance matches the gem quality, a damage and healing bonus is granted."
  - name: Vessel Resonance Top Right
    template: "Each level of Vessel Resonance unlocks equivalent Gem Mods in its domain. If the Vessel Resonance matches the gem quality, a damage and healing bonus is granted."
    params: [ 1 ]
  - name: Vessel Resonance Bottom Left
    template: "Each level of Vessel Resonance unlocks equivalent Gem Mods in its domain. If the Vessel Resonance matches the gem quality, a damage and healing bonus is granted."
    params: [ 1 ]
  - name: Vessel Resonance Bottom Right
    template: "Each level of Vessel Resonance unlocks equivalent Gem Mods in its domain. If the Vessel Resonance matches the gem quality, a damage and healing bonus is granted."
    params: [ 1 ]
  - name: Sanctuary
    template: "Your damage and healing with attacks, spells and runes is increased by %1% when hitting adjacent targets.\nAdditionally, consuming Harmony creates a field lasting %2 seconds, increasing your damage and healing done by %3% for each Harmony consumed."
    params: [ 10, 5, 2 ]
  - name: Guiding Presence
    template: "Gain an aura that shares your mantra with members of your group and increases your passive party bonuses by %1%."
    params: [ 33 ]
  - name: Fist Fighting Skill Boost
    template: +%1 fist fighting skill boost
    amount: 1
  - name: Augmented Thousand Fist Blows
    t1: Adds 40% critical extra damage for this spell.
    t2: -4s Cooldown
  - name: Augmented Mass Spirit Mend
    t1: +8% Base Healing
    t2: -4s Cooldown
  - name: Augmented Mystic Repulse
    t1: -4s Cooldown
    t2: +60% Base Damage
  - name: Augmented Chained Penance
    t1: Jumps to +1 additional target
    t2: +18% Base Damage
  - name: Augmented Flurry of Blows
    t1: Range increased by 1
    t2: +15% Base Damage

revelation:
  - name: Gift of Life
    template: "If an attack (except with agony damage) were to kill you but the overkill damage amounts to less than %1% of your maximum hit points, you will heal yourself for %1% of your maximum hit points. Only after that is the damage applied.\nIn addition, all your spell cooldowns are reduced by 60 seconds, and %1% of your maximum mana is restored.\nCooldown: %2 hours. The cooldown is only reduced while the character has a battle sign."
    tiers:
      - [ 20, 30 ]
      - [ 25, 20 ]
      - [ 30, 10 ]
  - name: Executioner's Throw
    template: "This spell throws your weapon on your target and jumps on %1 nearby enemies. Deals %2% additional damage to targets with less than 30% of their hit points.\nCooldown: %3 seconds."
    tiers:
      - [ 2, 100, 18 ]
      - [ 3, 125, 14 ]
      - [ 4, 150, 10 ]
  - name: Combat Mastery
    template: "Take 1% less damage per %1% missing hit points. This bonus is doubled while wielding a shield.\nDeal 1% more damage per %1% missing hit points of your target. This bonus is doubled while wielding a two-handed weapon."
    tiers:
      - [ 14 ]
      - [ 12 ]
      - [ 10 ]
  - name: Avatar of Steel
    template: "This spell transforms yourself into a powerful avatar for %1 seconds.\nWhile in this form, you benefit from %2 damage reduction and all your attacks are critical hits with %3 critical extra damage.\nCooldown: %4 minutes"
    tiers:
      - [ 15, 5, 5, 120 ]
      - [ 15, 10, 10, 90 ]
      - [ 15, 15, 15, 60 ]
  - name: Divine Grenade
    template: "This spell plants a marker at the feet of your target that explodes after 3 seconds, dealing holy damage. +16% base damage per additional stage.\nCooldown: %1 seconds"
    tiers:
      - [ 26 ]
      - [ 20 ]
      - [ 14 ]
  - name: Divine Empowerment
    template: "This support spell creates a field of holy energy around your feet for 5 seconds. As long as you stand in this field, your dealt damage increases by %1%.\nCooldown: %2 seconds"
    tiers:
      - [ 8, 32 ]
      - [ 10, 28 ]
      - [ 12, 24 ]
  - name: Avatar of Light
    template: "This spell transforms yourself into a powerful avatar for %1 seconds.\nWhile in this form, you benefit from %2 damage reduction and all your attacks are critical hits with %3 critical extra damage.\nCooldown: %4 minutes"
    tiers:
      - [ 15, 5, 5, 120 ]
      - [ 15, 10, 10, 90 ]
      - [ 15, 15, 15, 60 ]
  - name: Beam Mastery
    template: "Your beams now also hit tiles adjacent to the main beam, dealing %1% of the initial damage.\nIn addition, for each target hit by a beam spell, the cooldown of all other spells is reduced by 1 second (up to a maximum of 3 seconds) and the damage of beam spells is increased by %2% (up to a maximum of %3%)."
    tiers:
      - [ 25, 10, 30 ]
      - [ 40, 12, 36 ]
      - [ 70, 14, 42 ]
  - name: Lord of Destruction
    template: "Grants %1% more fire damage for Master of Flames, %2% more critical hit chance for Master of Thunder and %3% more critical damage for Master of Decay."
    tiers:
      - [ 2, 2, 15 ]
      - [ 3, 3, 25.5 ]
      - [ 4, 4, 30 ]
  - name: Avatar of Storm
    template: "This spell transforms yourself into a powerful avatar for %1 seconds.\nWhile in this form, you benefit from %2 damage reduction and all your attacks are critical hits with %3 critical extra damage.\nCooldown: %4 minutes"
    tiers:
      - [ 15, 5, 5, 120 ]
      - [ 15, 10, 10, 90 ]
      - [ 15, 15, 15, 60 ]
  - name: Twin Bursts
    template: "Decide wisely whether you want to cast ice or earth damage in a small area around you, as these two ring spells share the same cooldown. Both spells deal %1% additional damage to targets with more than 60% of their hit points.\nCooldown: %2 seconds"
    tiers:
      - [ 20, 22 ]
      - [ 40, 18 ]
      - [ 60, 14 ]
  - name: Blessing of the Grove
    template: "Your healing spells can achieve critical hits.\nAdditionally, your healing is increased by %1% against targets below 60% hit points. This effect is doubled against targets below 30% hit points."
    tiers:
      - [ 5 ]
      - [ 7.5 ]
      - [ 10 ]
  - name: Avatar of Nature
    template: "This spell transforms yourself into a powerful avatar for %1 seconds.\nWhile in this form, you benefit from %2 damage reduction and all your attacks are critical hits with %3 critical extra damage.\nCooldown: %4 minutes"
    tiers:
      - [ 15, 5, 5, 120 ]
      - [ 15, 10, 10, 90 ]
      - [ 15, 15, 15, 60 ]
  - name: Spiritual Outburst
    template: "This spell consumes your Harmony. Releases a massive attack chaining to 7 additional enemies. When used with full Harmony, repeats after 1 second for %1% of its original damage.\nCooldown: %2 seconds."
    tiers:
      - [ 37.5, 24 ]
      - [ 50, 20 ]
      - [ 62.5, 16 ]
  - name: Ascetic
    template: "Increases the Harmony base bonus by %1% and your autoattacks deal additional damage equal to %2% of your mantra."
    tiers:
      - [ 1, 100 ]
      - [ 2, 200 ]
      - [ 3, 300 ]
  - name: Avatar of Balance
    template: "This spell transforms yourself into a powerful avatar for %1 seconds.\nWhile in this form, you benefit from %2 damage reduction and all your attacks are critical hits with %3 critical extra damage.\nCooldown: %4 minutes"
    tiers:
      - [15, 5, 5, 120]
      - [15, 10, 10, 90]
      - [15, 15, 15, 60]
pointsPerCircle:
  - 50
  - 75
  - 100
  - 150
  - 200
slicesPerCircle:
  - 4
  - 8
  - 12
  - 8
  - 4

perks:
  dedication: [
    0, 1, 3, 8,
    8, 8, 0, 0, 1, 1, 3, 3,
    3, 3, 3, 8, 8, 8, 0, 0, 0, 1, 1, 1,
    1, 1, 3, 3, 8, 8, 0, 0,
    2, 2, 2, 2,
  ]
  conviction:
    knight: [
      40, 12, 37, 10,
      7, 5, 39, 5, 7, 6, 38, 6,
      14, 11, 40, 7, 13, 39, 11, 14, 37, 7, 13, 38,
      40, 6, 39, 6, 37, 5, 38, 5,
      9, 10, 8, 12,
    ]
    druid: [
      40, 29, 37, 31,
      34, 5, 39, 5, 34, 6, 38, 6,
      32, 30, 40, 34, 33, 39, 30, 32, 37, 34, 33, 38,
      40, 6, 39, 6, 37, 5, 38, 5,
      35, 31, 28, 29,
    ]
    paladin: [
      40, 22, 37, 18,
      15, 5, 39, 5, 15, 6, 38, 6,
      21, 19, 40, 15, 20, 39, 19, 21, 37, 15, 20, 38,
      40, 6, 39, 6, 37, 5, 38, 5,
      16, 18, 17, 22,
    ]
    sorcerer: [
      40, 27, 37, 24,
      34, 5, 39, 5, 34, 6, 38, 6,
      26, 25, 40, 34, 36, 39, 25, 26, 37, 34, 36, 38,
      40, 6, 39, 6, 37, 5, 38, 5,
      23, 24, 35, 27,
    ]
    monk: [ 
      40, 47, 37, 44,
      43, 5, 39, 5, 43, 6, 38, 6,
      45, 48, 40, 43, 46, 39, 48, 45, 37, 43, 46, 38,
      40, 6, 39, 6, 37, 5, 38, 5,
      41, 44, 42, 47,
    ]

  revelation:
    knight: [ 3, 2, 0, 1 ]
    druid: [ 12, 10, 0, 11 ]
    paladin: [ 6, 5, 0 , 4 ]
    sorcerer: [ 9, 8, 0, 7 ]
    monk: [ 15, 14, 0, 13 ]
